import { FC, PropsWithChildren } from 'react'
import { FormattedMessage } from 'react-intl'

import { Flex } from 'antd'

import { Title } from '../../components/text/Title'

type DescriptionProps = PropsWithChildren<{ titleId: string }>

const Description: FC<DescriptionProps> = ({ titleId, children }) => {
  return (
    <Flex vertical>
      <Title level={4}>
        <FormattedMessage id={titleId} />
      </Title>
      {children}
    </Flex>
  )
}

export { Description }
